export default {
  initText: 'Get Captcha',
  runText: 'Regain after {%s} second',
  resetText: 'Regain Captcha',
};
